import { Temporal } from "proposal-temporal";

import App from "./App.svelte";

const calendar = new Intl.DateTimeFormat().resolvedOptions();
let startDate = Temporal.now.plainDateISO().withCalendar(calendar);

const app = new App({
  target: document.body,
  props: {
    today: startDate,
  },
});

export default app;
